import React, { MouseEvent, useState } from 'react'

import cx from 'classnames'

import { IconButton } from '@driftt/tide-core'

import utilityStyles from '../../../styles/utility.module.css'
import styles from '../styles.module.css'

export interface ActionItemProps {
  icon: string
  text: string
  onClick: (event: MouseEvent<HTMLDivElement>) => void
  trackingId: string
}

const ActionItem: React.FC<ActionItemProps> = ({ icon, text, onClick, trackingId }) => {
  const [isHovered, setIsHovered] = useState(false)
  return (
    <div
      data-ocweb-id={trackingId}
      onMouseLeave={() => setIsHovered(false)}
      onMouseEnter={() => setIsHovered(true)}
      key={text}
      className={styles.actionItem}
      onClick={onClick}>
      <IconButton
        className={cx(styles.iconButtonStyle, { [styles.iconButtonStyleHovered]: isHovered })}
        size={'small'}
        icon={icon}
        height={7}
        width={7}
      />
      <div className={utilityStyles.semiBoldWeight}>{text}</div>
    </div>
  )
}

export default ActionItem
